import React from 'react'
import TableComponent, { TableOp } from '../../../components/table/TableOps';

export default class GuiaLog extends TableComponent {

  componentDidMount() {
    // this.cargarLog();
    let pgId = this.props.id;
    this.tableConfig(
      { dataUrl: `guia-log/${pgId}/log`, deleteUrl: '', deleteField: '', modUrl: '' },
      TableOp.Table('Historial de guía', [
        { label: 'Folio', id: 'g_folio' },
        { label: 'Estado', id: 'g_estado_descripcion' },
        { label: 'Descripcion', id: 'descripcion' },
        { label: 'Fecha de Modificacion', id: 'createdAt' },
        { label: 'Usuario', id: 'usuario' },
      ], []))
    this.table();
  }

  render() {
    return (
      <div>
        <div>
          <this.TableRender pagination={false} />
        </div>
      </div>
    )
  }
}
